export default __webpack_public_path__ + "static/media/3133.8f75aa1a.jpg";